import { contractRequest } from "@/portals/physician/api/transport";
import type { ReviewTriggerType } from "@/features/patient/records/api/dataPipelineApi";

// Module 6 — admin oversight of the shared review queue. Admin token; failures go
// through the one contract error parser (contractErrors.ts).

export interface ReviewQueueSummary {
  /** AWAITING_PHYSICIAN with no active holder. */
  unclaimedCount: number;
  /** Of those, waiting longer than UNCLAIMED_ALERT_HOURS. */
  overdueCount: number;
  oldestWaitingSince: string | null;
}

export interface AdminQueueItem {
  id: string;
  triggerType: ReviewTriggerType;
  medicineName: string;
  patientDisplayName: string;
  waitingSince: string;
  overdue: boolean;
}

export interface AssignResult {
  id: string;
  itemStatus: "IN_PHYSICIAN_REVIEW";
  physician: { userId: string; firstName: string; lastName: string };
}

export const getReviewQueueSummaryApi = () =>
  contractRequest<ReviewQueueSummary>("/api/v1/admin/review-queue/summary", { method: "GET", portal: "admin" });

/** Oldest first. */
export const listAdminReviewQueueApi = () =>
  contractRequest<{ items: AdminQueueItem[] }>("/api/v1/admin/review-queue", { method: "GET", portal: "admin" });

/** 404 REVIEW_ITEM_NOT_FOUND / PHYSICIAN_NOT_FOUND · 409 ITEM_NOT_ASSIGNABLE / PHYSICIAN_NOT_ELIGIBLE */
export const assignReviewItemApi = (id: string, physicianUserId: string) =>
  contractRequest<AssignResult>(`/api/v1/admin/review-items/${encodeURIComponent(id)}/assign`, {
    method: "POST",
    portal: "admin",
    body: { physicianUserId },
  });
